import { NJInlineMessage } from '@engie-group/fluid-design-system-react';
import PrototypeStudioLayout from '@shared/PrototypeStudioLayout';
import Loading from '@shared/Loading';
import type { PrototypeMeta } from '@shared/discoverPrototypes';
import { NetworkShell, PRODUCTION_REF_TABS, Size2MixTabs, TEST_PUC_NETWORK, useSize2MixRefNavigation, type ProductionRefTabId } from '@shared/size2mix-shell';
import ElectricityPage from './ElectricityPage';
import { useElectricity } from './hooks';

export const meta: PrototypeMeta = {
    title: 'Référence — Production › Électricité auxiliaires',
    description: "Contrats d'électricité auxiliaire du réseau test PUC — création, édition inline, options avancées et suppression.",
    tags: ['production', 'reference'],
    author: 'dv5886',
    status: 'reference',
    category: 'production/electricity',
    createdAt: '2026-10-20',
};

export default function RefProductionElectricity() {
    const nav = useSize2MixRefNavigation();
    const { data, isLoading, isError, error } = useElectricity();

    return (
        <PrototypeStudioLayout title={meta.title}>
            <NetworkShell network={TEST_PUC_NETWORK} activePage="production" onNavigate={nav.onNetworkNavigate} onPrimaryNavigate={nav.onPrimaryNavigate}>
                <Size2MixTabs<ProductionRefTabId> tabs={PRODUCTION_REF_TABS} activeId="electricity" onChange={(id) => nav.goTo(PRODUCTION_REF_TABS.find((tab) => tab.id === id)!.target)} />
                {isError ? (
                    <NJInlineMessage variant="error" title="Chargement impossible">{error.message}</NJInlineMessage>
                ) : isLoading || !data ? <Loading text="Chargement de l'électricité auxiliaire" scale="md" /> : <ElectricityPage data={data} />}
            </NetworkShell>
        </PrototypeStudioLayout>
    );
}
